import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Lock, Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_BASE = window.location.origin || '';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.access_token) {
        localStorage.setItem('admin_token', data.access_token);
        localStorage.setItem('vipgez_admin_token', data.access_token);
        localStorage.setItem('admin_user', JSON.stringify(data.admin));
        toast.success('Login successful');
        navigate('/admin/dashboard');
      } else {
        toast.error(data.detail || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Connection error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>Admin Login - GoTurkeyTransfer</title>
        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
        <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet" />
        <meta name="bingbot" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="bg-secondary border-border w-full max-w-md bg-secondary border-border">
        <CardHeader className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_27fa83fe-13fc-43b1-921c-bb11a32684e7/artifacts/9w38znq2_Go-Turkey-Transfer-logo.png"
            alt="GoTurkeyTransfer"
            className="h-10 mx-auto mb-4"
          />
          <CardTitle className="text-xl text-foreground">Admin Panel Login</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-foreground">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@goturkeytransfer.com"
                  className="pl-10 bg-muted/30 border-border text-foreground"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-foreground">Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="pl-10 bg-muted/30 border-border text-foreground"
                  required
                  data-testid="admin-password-input"
                />
              </div>
            </div>
            <Button
              type="submit"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
              disabled={isLoading}
              data-testid="admin-login-button"
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Logging in...
                </>
              ) : (
                'Login'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
      </div>
    </>
  );
};

export default AdminLoginPage;
